<div *ngIf="activeCustomer$ | async as customer; else notLoggedIn">
    <div class="md:flex md:gap-2 md:items-center">
        <a
            class="hidden md:flex items-center gap-2 md:border md:pl-4 md:pr-4 md:pt-2 md:p-2 rounded-[6px] md:border md:border-black bg-white text-muted"
            [routerLink]="['/seller']"
        >
            <img
                alt=""
                class="w-4 h-4"
                src="../../../../assets/icons/switch-icon.svg"
            />
            <span class="text-[16px] font-medium">Switch to Seller</span>
        </a>
        <a
            class="btn btn-light text-muted flex"
            [routerLink]="['/account/details']"
        >
            <img
                alt="Cart"
                class="sm:w-6 sm:h-6"
                src="../../../../assets/icons/user-icon.svg"
            />
            <span class="hidden sm:inline d-none d-sm-inline ml-1 text-[16px] font-medium">{{
                userName(customer)
            }}</span>
        </a>
    </div>
</div>
<ng-template #notLoggedIn>
    <div class="md:flex md:gap-2">
        <a
            class="btn btn-light text-muted flex md:border md:pl-4 md:pr-4 md:pt-2 md:p-2 rounded-[6px] md:border md:border-black"
            [routerLink]="['account/sign-in']"
        >
            <img
                alt="Cart"
                class="w-6 h-6 md:hidden"
                src="../../../../assets/icons/user-icon.svg"
            />
            <span class="hidden sm:inline text-[16px] font-medium"
                >Sign In</span
            ></a
        >
        <a
            class="bg-brand-primary text-muted flex md:border md:pl-4 md:pr-4 md:pt-2 md:p-2 rounded-[6px] md:border md:border-black"
            [routerLink]="['account/register']"
        >
            <span class="hidden sm:inline text-white text-[16px] font-medium"
                >Sign Up</span
            ></a
        >
    </div>
</ng-template>
